import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as l from "react";
import { s as a, c as r } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var c = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, e),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ l.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M6 1.372v29.256C1.842 28.788.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .976-4.663 5.134-6.503Zm20 29.256V1.39c4.186 1.83 5.167 6.519 5.167 6.519.664 2.757.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-.975 4.664-5.133 6.504ZM16 9l-1.136 2.111c-.128.23-.36.209-.59.08l-.822-.424.613 3.243c.129.593-.285.593-.489.337l-1.434-1.602-.233.813c-.027.107-.145.22-.322.193l-1.814-.38.476 1.726c.102.385.182.544-.103.645l-.646.303 3.122 2.53a.407.407 0 0 1 .142.423l-.273.894c1.075-.124 2.039-.31 3.114-.424.095-.01.254.146.253.256L15.716 23h.523l-.083-3.27c0-.109.144-.272.239-.262 1.076.114 2.039.3 3.114.424l-.273-.894a.407.407 0 0 1 .142-.424l3.122-2.529-.646-.303c-.285-.101-.206-.26-.104-.645l.477-1.727-1.814.38c-.177.027-.295-.085-.322-.192l-.233-.813-1.434 1.602c-.204.256-.617.256-.489-.337l.613-3.243-.822.424c-.23.129-.462.15-.59-.08L16 9Z",
      clipRule: "evenodd"
    }
  )
), i = a(c)`
  ${t}
  ${r}
`, C = i;
export {
  C as default
};
